import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { useChecklist } from "@/react/hooks/useChecklist";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckListSection } from "./CheckListSection";
import { StepContent } from "./steps/StepContent";

export interface CheckListSectionsProps {
  variant?: "default" | "compact";
}

export const CheckListSections = ({
  variant = "default",
}: CheckListSectionsProps) => {
  const { sectionsWithFocus } = useChecklist();

  const nextStep = useMemo(
    () =>
      sectionsWithFocus
        .flatMap(section => section.steps ?? [])
        .find(step => step.focus),
    [sectionsWithFocus],
  );

  if (variant === "compact") {
    if (!nextStep) {
      return null;
    }

    return (
      <div className="p-6">
        <div className="mb-3">
          <Typography.LabelSm weight="semibold" color="text-default">
            {t("admin_dashboard.getting_started.next_up")}
          </Typography.LabelSm>
        </div>
        <StepContent step={nextStep} />
      </div>
    );
  }

  return (
    <>
      {sectionsWithFocus.map(section => (
        <CheckListSection key={section.title} section={section} />
      ))}
    </>
  );
};
